import VehicleCard from "./VehicleCard";

function VehicleGrid({ vehicles, onBookNow }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
      {vehicles.map((v) => (
        <VehicleCard key={v.id} vehicle={v} onBookNow={onBookNow} />
      ))}
    </div>
  );
}

export default VehicleGrid;
